import * as types from "./mutation-types";

const mutations = {
  [types.SET_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_LOADING_STATUS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_TEAM_DISCUSSION](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_ADD_CREATOR_TO_TEAM](state, bool) {
    state.addCreatorToTeam = bool;
  },

  [types.SET_TEAM_MEMBERS_INVITE_MODE](state, mode) {
    state.teamMembersInviteMode = mode;
  }
};

export default mutations;
